import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import RegisterDownload from "../views/register-download/RegisterDownload.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: "嗨圈官网-找到你感兴趣的圈子",
      description: "嗨圈-找到你感兴趣的圈子。社交平台、达人入驻、渠道合作，多种变现方式，助你开启创收新生活。",
      keywords: "嗨圈,社交圈子,达人入驻,渠道合作,内容变现,社交平台"
    }
  },
  {
    path: "/register-download",
    name: "registerDownload",
    component: RegisterDownload,
    meta: {
      title: "嗨圈-注册下载",
      description: "嗨圈注册下载页，手机网页版直接游玩，或下载 Android 客户端。",
      keywords: "嗨圈,注册,下载,手机网页版,Android"
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 无需鉴权即可访问的路由（白名单）
const PUBLIC_PATHS = ["/register-download"];

function updatePageMeta(to) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.getElementsByTagName("head")[0].appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", to.meta.description);
  }

  if (to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.setAttribute("name", "keywords");
      document.getElementsByTagName("head")[0].appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", to.meta.keywords);
  }
}

router.beforeEach((to, from, next) => {
  updatePageMeta(to);

  if (PUBLIC_PATHS.includes(to.path)) {
    return next();
  }

  // 其它路由的鉴权逻辑可在此扩展
  next();
});

export default router;
